/* StoryInfo Info component on the Storyboard component */
   import React from "react";
   import Row from "react-bootstrap/Row";
   import Col from "react-bootstrap/Col";
   import styles from "../../../styles/Callsheets.module.css";
   
   const StoryInfo = () => {
     return (
       <div>
       <Row className="mb-3 mt-3">
         <Col className="d-none d-md-block" md={2}></Col>     
         <Col xs={12} md={8} >
           <div className={`text-center px-3 py-2 ${styles.SubTitle6 }`}>
           <p className={`${styles.Red} text-center`}>INFO</p> 
           <hr className={`mt-2 mb-0`}/> 
           <p className="pt-2">
           Use the <span className={`${styles.Red}`}>Add/Change Storyboard</span> tab to upload Storyboard files.
           </p>
           <p className="pt-2">
           Use the "Templates" tab to download a Storyboard template 
          if one is needed.
           </p>
           <p className="pt-2">
           Use the <span className={`${styles.Red}`}>Storyboard URL</span> tab to add or change
           the Storyboard Video URL if one exists.
           </p>
           <hr className={`mt-2 mb-0`}/>
            </div>
         </Col>
       </Row>
       </div>
     )
   }

export default StoryInfo